module.exports = __webpack_public_path__ + "static/media/nepzaApplication.0ad22960.pdf";